import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Phonebookupload = ()=>{
    const [phonebookupload, setPhonebookupload] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`phonebookUpload?page=${page}`);
            setPhonebookupload(data.data);
            setLastPage(data.meta.last_page)
            //console.log(data.data)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`phonebookupload/${id}`);
            setPhonebookupload(phonebookupload.filter((phonebookupload) => phonebookupload.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Phonebook Uploads'}>
            <InnerNav createLink={'/phonebookuploadCreate'} listLink={'/phonebookupload'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Phonebook </th>
                                    <th className="px-4 py-3">Uploadfile </th>
                                    <th className="px-4 py-3">Timein </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {phonebookupload.map((phonebookupload)=>{
                                         return(
                                             <tr key={phonebookupload.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{phonebookupload.id}</td>
                                                 <td className="px-4 py-3 text-sm">{phonebookupload.phonebook.name}</td>
                                                 <td className="px-4 py-3 text-sm">{phonebookupload.upload_file}</td>
                                                 <td className="px-4 py-3 text-sm">{phonebookupload.time_in}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/phonebookupload/${phonebookupload.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(phonebookupload.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Phonebookupload;